"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upperFirst = upperFirst;
/**
 * Update the first letter
 * @example
 * upperFirst("thomas") => Thomas
 *
 * @param str
 * @returns {string}
 */
function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}